import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { LoginCallbackComponent } from './components/login-callback/login-callback.component';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'auth/callback', component: LoginCallbackComponent },
  // Service connection callbacks
  {
    path: 'auth/spotify/connect',
    component: AuthCallbackComponent,
    data: { provider: 'spotify', type: 'connect' }
  },
  {
    path: 'auth/spotify/callback',
    component: AuthCallbackComponent,
    data: { provider: 'spotify', type: 'callback' }
  },
  {
    path: 'auth/discogs/connect',
    component: AuthCallbackComponent,
    data: { provider: 'discogs', type: 'connect' }
  },
  {
    path: 'auth/discogs/callback',
    component: AuthCallbackComponent,
    data: { provider: 'discogs', type: 'callback' }
  },
  // Legacy routes (keep for compatibility)
  { path: 'music/callback', component: AuthCallbackComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: '/dashboard' }
];
